var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenuesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 5.79086 15.2091 4 13 4H11C8.79086 4 7 5.79086 7 8C7 10.2091 8.79086 12 11 12H13C15.2091 12 17 13.7909 17 16C17 18.2091 15.2091 20 13 20H11C8.79086 20 7 18.2091 7 16M12 2L12 22",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenuesIcon);
export default __webpack_public_path__ + "static/media/revenues_icon.63fcd08bbfa2c1a31c320cda0bd02e35.svg";
export { ForwardRef as ReactComponent };